const generateCycleReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_CYCLE_DATA':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default generateCycleReducer;